var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Tabs as MUITabs, Tab as MUITab, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
import { Icon } from "../Icon";
export const StyledTabs = styled(MUITabs)(({ theme }) => ({
    "& .MuiTab-root": Object.assign(Object.assign({ border: `${convertPxToRem(2.5)} solid "transparent"`, color: theme.palette.secondaryText.main }, theme.typography.mediumText), { minWidth: "unset", minHeight: "unset", maxHeight: "unset", width: "fit-content", padding: convertPxToRem(12), "&:hover": {
            color: theme.palette.primaryBlackText.main,
            backgroundColor: theme.palette.treezGreen[2],
        }, "&.Mui-disabled": {
            color: theme.palette.disabledText.main,
            "> .material-symbols-rounded": {
                color: theme.palette.disabledText.main,
            },
        }, "&:focus-visible": {
            border: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlackText.main}`,
            zIndex: 1,
        } }),
    ".material-symbols-rounded": {
        color: theme.palette.secondaryText.main,
    },
}));
export const StyledUnderlinedNavTabs = styled(StyledTabs, {
    shouldForwardProp: (prop) => prop !== "fillHeight",
})(({ theme, fillHeight }) => (Object.assign(Object.assign({ "& .MuiTab-root": {
        border: `${convertPxToRem(2.5)} solid transparent`,
        "&.Mui-selected": {
            color: theme.palette.treezGreen[8],
            "> .material-symbols-rounded": {
                color: theme.palette.treezGreen[8],
            },
        },
        "&:hover": {
            border: `${convertPxToRem(2.5)} solid ${theme.palette.treezGreen[2]}`,
            "&:focus-visible": {
                border: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlackText.main}`,
            },
        },
        "> span": {
            paddingRight: convertPxToRem(6),
        },
    }, ".MuiTabs-indicator": {
        backgroundColor: theme.palette.treezGreen[8],
    } }, (fillHeight && { height: "100%" })), (fillHeight && {
    ".MuiTabs-flexContainer": {
        height: "100%",
    },
}))));
export const StyledFilledNavTabs = styled(StyledTabs, {
    shouldForwardProp: (prop) => prop !== "fillHeight",
})(({ theme, fillHeight }) => (Object.assign(Object.assign({ "& .MuiTab-root": {
        minHeight: convertPxToRem(40),
        border: `${convertPxToRem(2.5)} solid transparent`,
        "> span": {
            paddingRight: convertPxToRem(6),
        },
        "&.Mui-selected": Object.assign(Object.assign({}, theme.typography.mediumTextStrong), { color: theme.palette.primaryBlackText.main, backgroundColor: theme.palette.midribGreen.main, borderRadius: convertPxToRem(16), "> span": {
                color: theme.palette.primaryBlackText.main,
            } }),
        "&:hover": {
            borderRadius: convertPxToRem(16),
            color: theme.palette.primaryBlackText.main,
            "> span": {
                color: theme.palette.primaryBlackText.main,
            },
        },
        "&:focus-visible": {
            borderRadius: convertPxToRem(16),
        },
    } }, (fillHeight && { height: "100%", alignItems: "center" })), { "& .MuiTabs-indicator": {
        height: 0,
    } })));
export const Tabs = (_a) => {
    var { ariaLabel, children, fillHeight = false, testId, variant = "underlined" } = _a, rest = __rest(_a, ["ariaLabel", "children", "fillHeight", "testId", "variant"]);
    switch (variant) {
        case "filled":
            return (_jsx(StyledFilledNavTabs, Object.assign({}, rest, { "aria-label": ariaLabel, "data-testid": testId, fillHeight: fillHeight, variant: "scrollable" }, { children: children })));
            break;
        default:
            return (_jsx(StyledUnderlinedNavTabs, Object.assign({}, rest, { "aria-label": ariaLabel, "data-testid": testId, fillHeight: fillHeight, variant: "scrollable" }, { children: children })));
            break;
    }
};
export const Tab = (_a) => {
    var { iconName, testId } = _a, rest = __rest(_a, ["iconName", "testId"]);
    return (_jsx(MUITab, Object.assign({ "data-testid": testId, disableFocusRipple: true, disableRipple: true, icon: iconName && (_jsx(Icon, { iconName: `${iconName}`, fontSize: "medium" })), iconPosition: "start" }, rest)));
};
